<template>
    <el-dialog
        class="add"
        :visible.sync="editEstimeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="400px"
        title="修改预计解决时间"
    >
        <el-form ref="form" :rules="rules" :model="form">
            <el-row :gutter="20">
                <el-col :span="24">

                    <el-form-item label="" size="mini">
                            <el-date-picker
                                v-model="form.estimate_time"
                                prefix-icon="el-icon-date theme-color"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>

                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editEstimeVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            form: {
                estimate_time: "",
            },
            rules: {
                estimate_time: [{ required: true, message: "请选择日期" }],
            },
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$refs["form"].clearValidate();
            this.$refs["form"].resetFields();
            this.$emit("update:editEstimeVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    // status: 50 已拒绝
                    oaApi
                        .workOrdersList(
                            { ...this.form},
                            "put",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success("操作成功");
                                    this.$parent.workOrdersList();
                                }
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        editEstimeVisible: Boolean,
        tableItem: () => {},
    },
    watch: {
        editEstimeVisible: {
            handler(val) {
                this.form.estimate_time = this.tableItem.estimate_time;
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-input--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
